import { render, staticRenderFns } from "./panel_vipPower.vue?vue&type=template&id=b08bff96&scoped=true&"
import script from "./panel_vipPower.vue?vue&type=script&lang=js&"
export * from "./panel_vipPower.vue?vue&type=script&lang=js&"
import style0 from "./panel_vipPower.vue?vue&type=style&index=0&id=b08bff96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08bff96",
  null
  
)

export default component.exports